import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MessageList from "./MessageList";
import ChatInput from "./ChatInput";
import { FormattedMessage, useIntl } from "react-intl";
import AvatarView from "../../Common/AvatarView";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import HomeIcon from "@material-ui/icons/Home";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Badge from "@material-ui/core/Badge";
import { Tooltip } from "@material-ui/core";
import { clearMessages, setToolTab } from "../../../actions/toolareaActions";

const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    overflowY: "auto",
  },
  icon: {
    display: "block",
    height: 30,
    width: 30,
  },
  addButton: {
    border: "1px solid #EAEDF0",
    padding: 5,
    margin: 3,
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  chatBar: {
    display: "flex",
    width: 90,
    flexDirection: "column",
    boxShadow: "0 1px 0 0 #eaedf0",
    overflowY: "auto",
    alignItems: "center",
  },
  selectedChat: {
    display: "flex",
    marginTop: 15,
    float: "right",
    padding: 4,
  },
  avatar: {
    margin: 5,
    marginTop: 3,
    cursor: "pointer",
  },
  avatar2: {
    marginLeft: 12,
    marginTop: 3,
    cursor: "pointer",
  },
  selectedPeerName: {
    marginLeft: 6,
    marginTop: 8,
    color: "gray",
  },
});

const PulsingBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#f3465a",
    marginTop: 10,
    "&::after": {
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      border: `3px solid #f3465a`,
      content: '""',
    },
  },
  "@keyframes ripple": {
    color: "#f3465a",
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const Chat = (props) => {
  const { classes } = props;
  const intl = useIntl();
  var firstPeer = [
    {
      displayName: intl.formatMessage({
        id: "chat.allPeers",
        defaultMessage: "All Peers",
      }),
    },
  ];

  const me = useSelector((state) => state.me);
  const allPeers = useSelector((state) => Object.values(state.peers));
  const privateChat = useSelector((state) => state.privateChat);
  const dispatch = useDispatch();
  const peerOptions = firstPeer.concat(allPeers);
  const [avatarOptions, setAvatarOptions] = React.useState([]);
  const [avatarOptionsIds, setAvatarOptionsIds] = React.useState([]);
  const [selectedPeer, setSelectedPeer] = React.useState(peerOptions[0]);
  const unread = useSelector((state) => state.toolarea.unreadPrivateMessages);
  const unreadPublic = useSelector((state) => state.toolarea.unreadMessages);
  const currentToolTab = useSelector((state) => state.toolarea.currentToolTab);
  const [privateChatMessages, setPrivateChatMessages] = React.useState(
    privateChat.get(chatId)
  );
  var chatId;
  if (selectedPeer.id) {
    if (me.id > selectedPeer.id) chatId = me.id + selectedPeer.id;
    else chatId = selectedPeer.id + me.id;
  }

  var dm = [];
  useEffect(() => {
    let privatMessageList = privateChat.get(chatId);
    if (privatMessageList) privatMessageList = [...privatMessageList];
    setPrivateChatMessages(privatMessageList);

    for (let i = 0; i < privateChat.size; i++) {
      let key = Array.from(privateChat.keys())[i];
      if (key.includes(me.id)) {
        if (key.split(me.id)[0] === "") dm.push(key.split(me.id)[1]);
        else dm.push(key.split(me.id)[0]);
      }
    }

    for (let i = 0; i < allPeers.length; i++) {
      dm.map((m) => {
        if (m === allPeers[i].id) {
          if (avatarOptionsIds.indexOf(allPeers[i].id) === -1) {
            avatarOptionsIds.push(allPeers[i].id);
            avatarOptions.push({
              id: allPeers[i].id,
              displayName: allPeers[i].displayName,
              profilePicture: allPeers[i].profilePicture,
            });
          }
        }
      });
    }
    setAvatarOptions([...avatarOptions]);
  }, [privateChat, selectedPeer]);

  const ITEM_HEIGHT = 48;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleBagdeContent = (id) => {
    if (selectedPeer.id === id) return 0;
    let cid;
    if (me.id > id) cid = me.id + id;
    else cid = id + me.id;
    if (unread.get(cid)) return unread.get(cid);
    else return 0;
  };

  return (
    <div className={classes.root}>
      <div className={classes.chatBar}>
        <IconButton
          className={classes.addButton}
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <PersonAddIcon className={classes.icon} />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "20ch",
            },
          }}
        >
          {peerOptions.map((option) => (
            <MenuItem
              key={option}
              onClick={() => {
                setSelectedPeer(option);
                if (option.id) dispatch(setToolTab("privateChat"));
                else dispatch(setToolTab("chat"));
                handleClose();
              }}
            >
              {option.displayName}
            </MenuItem>
          ))}
        </Menu>
        <Tooltip title={peerOptions[0].displayName}>
          <PulsingBadge
            classes={{ badge: classes.customBadge }}
            max={5000}
            badgeContent={unreadPublic}
          >
            <IconButton className={classes.addButton}>
              <HomeIcon
                className={classes.icon}
                onClick={() => {
                  dispatch(setToolTab("chat"));
                  setSelectedPeer(peerOptions[0]);
                }}
              />
            </IconButton>
          </PulsingBadge>
        </Tooltip>

        <div
          style={{
            overflowY: "auto",
            marginLeft: 5,
            height: "86%",
            width: "-webkit-fill-available",
          }}
        >
          {avatarOptions.map((a) => (
            <Tooltip title={a.displayName}>
              <PulsingBadge
                classes={{ badge: classes.customBadge }}
                max={5000}
                badgeContent={
                  handleBagdeContent(a.id) ? handleBagdeContent(a.id) : 0
                }
              >
                <AvatarView
                  alt={a.displayName}
                  src={a.profilePicture}
                  className={unread === 0 ? classes.avatar : classes.avatar2}
                  id={a.id}
                  displayName={a.displayName}
                  onClick={() => {
                    let cid;
                    if (me.id > a.id) cid = me.id + a.id;
                    else cid = a.id + me.id;
                    setSelectedPeer(a);
                    dispatch(setToolTab("privateChat"));
                    dispatch(clearMessages(cid));
                  }}
                />
              </PulsingBadge>
            </Tooltip>
          ))}
        </div>
      </div>
      <hr style={{ color: "gray", opacity: 0.5 }} />
      <div style={{ width: "-webkit-fill-available" }}>
        {selectedPeer && (
          <h3 className={classes.selectedPeerName}>
            {selectedPeer.displayName}
          </h3>
        )}
        <div style={{ height: "86%" }}>
          <MessageList
            currentToolTab={currentToolTab}
            privateChatMessages={privateChatMessages}
            selectedPeer={selectedPeer}
          />
        </div>
        <div style={{ position: "absolute", bottom: 0 }}>
          <ChatInput
            selectedPeerId={selectedPeer ? selectedPeer.id : undefined}
          />
        </div>
      </div>
    </div>
  );
};

Chat.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Chat);
